import { Getter } from 'vuex'
import { RootState } from '@/store/types'
import { ArticleState } from '../types'

const isLoadingFields: Getter<ArticleState, RootState> = (state) => {
  return state.isLoadingFields
}

export default isLoadingFields
